import "./foodmenu.css";
import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

function RevealOnScroll({ children, delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: "easeOut", delay }}
    >
      {children}
    </motion.div>
  );
}

function FoodMenu() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="foodmenu-container">
        <img
          src="https://i.imgur.com/7giXUUP.jpeg"
          alt=""
          className="food-menu-hero"
        />
        <h1 className="food-menu-header">BREAKFAST - ALL DAY</h1>
      </div>
      <div className="food-menu-items-container">
        {/* CATEGORY */}
        <div className="category">
          {/* BREAKFAST */}
          <RevealOnScroll>
            <h2 className="category-header">OMELETS</h2>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="item-container-breakfast">
              <h4 className="item-name">Sausage & Cheese</h4>
              <p className="item-price">$13</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="item-container-breakfast">
              <h4 className="item-name">Mushroom, Spinach & Mozzarella</h4>
              <p className="item-price">$13</p>
            </div>
          </RevealOnScroll>
          <RevealOnScroll>
            <div className="item-container-breakfast">
              <h4 className="item-name">Spinach & Feta Cheese</h4>
              <p className="item-price">$13</p>
            </div>
          </RevealOnScroll>
        </div>
        <RevealOnScroll>
          <h2 className="category-header">BAGELS</h2>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Cream Cheese</h4>
            <p className="item-price">$5.5</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Smoked Salmon & Cream Cheese</h4>
            <p className="item-price">$9</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Bacon, Egg & Cheddar</h4>
            <p className="item-price">$9.5</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <h2 className="category-header">AVOCADO TOASTS</h2>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Smoked Salmon</h4>
            <p className="item-price">$13</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Feta & Confit Cherry Tomato</h4>
            <p className="item-price">$13</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Fried Egg or Poached Egg</h4>
            <p className="item-price">$13</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <h2 className="category-header">PANINIS</h2>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">
              Fresh Mozzarella, Confit Cherry Tomato & Pesto
            </h4>
            <p className="item-price">$12</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">
              Grilled Cheese, Confit Cherry Tomato & Avocado
            </h4>
            <p className="item-price">$12</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <h2 className="category-header">
            BREAKFAST SANDWICHES (Roll or Croissant (+$2))
          </h2>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Egg & Cheddar</h4>
            <p className="item-price">$7</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Bacon, Egg & Cheddar</h4>
            <p className="item-price">$10</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Sausage, Egg & Cheese</h4>
            <p className="item-price">$10</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <h2 className="category-header">MENEMEN</h2>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Menemen (Shakshouka)</h4>
            <p className="item-price">$14</p>
          </div>
        </RevealOnScroll>

        {/* LUNCH */}
        <h1 className="food-menu-header">LUNCH - 12 PM to 6 PM</h1>
        <RevealOnScroll>
          <div className="item-container">
            <h4 className="item-name">Vista Burger</h4>
            <div className="inside-item">
              <p className="item-des">Served with fries</p>
              <p className="item-price">$15</p>
            </div>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container">
            <h4 className="item-name">Grilled Chicken & Pesto Panini</h4>
            <div className="inside-item">
              <p className="item-des">Served with salad</p>
              <p className="item-price">$14</p>
            </div>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container">
            <h4 className="item-name">Turkey, Pesto & Mozzarella Panini</h4>
            <div className="inside-item">
              <p className="item-des">Served with salad</p>
              <p className="item-price">$14</p>
            </div>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container">
            <h4 className="item-name">Grilled Chicken Plate</h4>
            <div className="inside-item">
              <p className="item-des">Served with salad & french fries</p>
              <p className="item-price">$15</p>
            </div>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container">
            <h4 className="item-name">
              Smoked Salmon, Avocado & Greens Croissant
            </h4>
            <div className="inside-item">
              <p className="item-des">
                Avocado, smoked salmon, mixed greens and capers in croissant
              </p>
              <p className="item-price">$12</p>
            </div>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container">
            <h4 className="item-name">Caprese Sandwich</h4>
            <div className="inside-item">
              <p className="item-price">$12</p>
            </div>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container">
            <h4 className="item-name">Avocado Chicken Club Sandwich</h4>
            <div className="inside-item">
              <p className="item-des">
                Avocado, aioli sauce, turkey, tomato with salad
              </p>
              <p className="item-price">$12</p>
            </div>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container">
            <h4 className="item-name">Buratta Skillet</h4>
            <div className="inside-item">
              <p className="item-des">
                Roasted tomato, garlic, basil & burrata, served with Sourdough
                bread and herb butter
              </p>
              <p className="item-price">$15</p>
            </div>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">French Fries</h4>
            <p className="item-price">$3</p>
          </div>
        </RevealOnScroll>
        <RevealOnScroll>
          <div className="item-container-breakfast">
            <h4 className="item-name">Truffle French Fries</h4>
            <p className="item-price">$5</p>
          </div>
        </RevealOnScroll>
      </div>
    </motion.div>
  );
}

export default FoodMenu;
